import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';

/*
 * Style.
 */

const StyledTitleDiv = styled.div`
  color: ${(p) => p.theme.banner.primaryText};
  margin-bottom: 5px;
  ${ellipsis()};
  font-weight: ${fontWeights.bold};
`;

/*
 * Component.
 */

export const BannerContentTitle: FC<PropsWithChildren<unknown>> = (props) => (
  <StyledTitleDiv>{props.children}</StyledTitleDiv>
);
